import { WireActions, WireApiActions } from '@discover/store/actions/discover.actions';
import { DiscoverState } from '@discover/store/models/discover.models';
import { createReducer, on } from '@ngrx/store';

export const initialState: DiscoverState = {
    wires: [],
    isLoading: false,
    topics: new Map<string, StorytellingTopicRecord>(),
    storedViewStates: null,
    currentSelectedViewState: null,
    isAttachToTopicListLoading: false,
};

export const wiresReducer = createReducer(
    initialState,
    on(WireApiActions.stopPolling, (): DiscoverState => {
        return initialState;
    }),
    on(WireActions.loading, (state, action): DiscoverState => {
        return {
            ...state,
            isLoading: action.isLoading,
        };
    }),
    on(WireApiActions.startPolling, (state): DiscoverState => {
        return {
            ...state,
            isLoading: true,
        };
    }),
    on(WireApiActions.loadWiresSuccess, WireApiActions.loadWiresError, (state): DiscoverState => {
        return {
            ...state,
            isLoading: false,
        };
    }),
    on(WireApiActions.loadWiresSuccess, (state, { wires }): DiscoverState => {
        return {
            ...state,
            wires: [
                ...state.wires,
                ...wires.filter(wire => {
                    return !state.wires.find(item => item.Guid === wire.Guid);
                }),
            ],
        };
    }),

    on(WireActions.addWire, (state, wire): DiscoverState => {
        if (state.wires.find(item => item.Guid === wire.Guid)) {
            return state;
        }
        return { ...state, wires: [...state.wires, wire] };
    }),
    on(WireApiActions.attachItem, (state): DiscoverState => {
        return { ...state, isAttachToTopicListLoading: true };
    }),
    on(WireApiActions.attachItemSuccess, (state): DiscoverState => {
        return { ...state, isAttachToTopicListLoading: false };
    })
);
